var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleanerSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.005 512.005",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0B394"
    },
    d: "M146.155,217.769c-14.534-0.645-26.102-12.635-26.102-27.321c0-15.096,12.236-27.344,27.344-27.344 c1.36,0,2.696,0.094,4.008,0.293"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0B394"
    },
    d: "M389.735,217.769c14.534-0.645,26.114-12.635,26.114-27.321c0-15.096-12.248-27.344-27.356-27.344 c-1.36,0-2.707,0.105-4.008,0.293"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E86B7"
    },
    d: "M395.715,383.465v106.401H140.203V383.465c0-40.026,32.455-72.481,72.481-72.481h110.538 C363.26,310.984,395.715,343.438,395.715,383.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#527BA3"
    },
    d: "M276.75,324.591v165.274h-17.581V324.591c0-4.852,3.926-8.791,8.791-8.791 C272.812,315.801,276.75,319.739,276.75,324.591z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 242.818,
    cy: 459.771,
    r: 8.595
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 242.818,
    cy: 391.006,
    r: 8.595
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 242.818,
    cy: 425.394,
    r: 8.595
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0E7F9"
    },
    cx: 479.577,
    cy: 187.979,
    r: 32.428
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0E7F9"
    },
    cx: 28.329,
    cy: 32.879,
    r: 19.535
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF7C38"
    },
    d: "M80.356,78.2L80.356,78.2c-7.336,0-13.283,5.947-13.283,13.283v353.184H93.64V91.483 C93.639,84.147,87.692,78.2,80.356,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#527BA3"
    },
    d: "M257.35,310.981h-44.663c-40.033,0-72.488,32.454-72.488,72.488v106.402h44.663V383.469 C184.863,343.435,217.316,310.981,257.35,310.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CBA4"
    },
    d: "M355.619,295.149L307.505,330.1c-23.582,17.136-55.521,17.136-79.115,0l-48.114-34.951 c-25.422-18.472-39.171-49.016-36.147-80.299l7.501-77.568l0.844-8.791c0.281-2.965,0.68-5.896,1.184-8.791 c9.576-55.099,57.514-96.075,114.289-96.075c29.888,0,57.314,11.346,78.001,30.134c18.624,16.901,31.763,39.839,36.299,65.941 c0.504,2.895,0.902,5.825,1.184,8.791l0.844,8.791l7.501,77.568C394.801,246.133,381.053,276.677,355.619,295.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M383.432,128.497H152.475c5.743-59.483,55.72-104.865,115.473-104.865 c29.876,0,57.314,11.346,78.001,30.122C366.624,72.542,380.56,98.749,383.432,128.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0B394"
    },
    d: "M174.066,231.866c-0.809,13.678,3.645,27.133,12.459,37.624l50.285,61.792 c2.625,3.129,5.603,5.755,8.826,7.853c-6.048-2.11-11.861-5.134-17.241-9.037l-48.114-34.951 c-25.422-18.472-39.171-49.016-36.147-80.299l8.333-86.358c5.696-58.897,54.759-103.975,113.75-104.83 c-36.334,0.879-77.478,35.127-79.622,71.602L174.066,231.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54728"
    },
    d: "M266.214,23.664c-0.258,0.012-0.504,0.012-0.762,0.035c-36.147,1.324-76.724,35.35-78.857,71.567 l-2.555,33.231l-31.576,0.033v-0.035c0.539-5.52,1.453-10.924,2.719-16.175c0.012-0.047,0.023-0.094,0.035-0.129 c0.223-0.879,0.445-1.758,0.68-2.637c0.234-0.867,0.481-1.746,0.727-2.614c0.504-1.735,1.055-3.458,1.641-5.145 c1.453-4.243,3.153-8.369,5.087-12.365c1.137-2.391,2.368-4.747,3.692-7.044c1.723-3.071,3.61-6.048,5.626-8.931 c1.489-2.168,3.071-4.266,4.723-6.317c12.588-15.717,29.161-28.024,48.114-35.455c4.934-1.957,10.045-3.575,15.284-4.817 c0.867-0.199,1.746-0.41,2.625-0.598c0.879-0.188,1.758-0.363,2.649-0.539c0.891-0.164,1.782-0.328,2.672-0.481 c3.575-0.609,7.197-1.043,10.877-1.289c0.914-0.059,1.84-0.117,2.766-0.164C263.659,23.723,264.936,23.688,266.214,23.664z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M151.921,498.661c-4.856,0-8.791-3.936-8.791-8.791v-33.001c0-1.881-1.531-3.411-3.411-3.411H20.992 c-1.88,0-3.411,1.53-3.411,3.411v33.001c0,4.855-3.935,8.791-8.791,8.791S0,494.725,0,489.87v-33.001 c0-11.575,9.416-20.992,20.992-20.992h118.727c11.575,0,20.992,9.416,20.992,20.992v33.001 C160.711,494.725,156.776,498.661,151.921,498.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M35.036,495.73c-3.237,0-5.86-2.624-5.86-5.86v-41.296c0-3.236,2.623-5.86,5.86-5.86 s5.86,2.624,5.86,5.86v41.296C40.896,493.106,38.272,495.73,35.036,495.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M125.677,495.73c-3.237,0-5.86-2.624-5.86-5.86v-41.296c0-3.236,2.623-5.86,5.86-5.86 s5.86,2.624,5.86,5.86v41.296C131.537,493.106,128.913,495.73,125.677,495.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M57.696,495.73c-3.237,0-5.86-2.624-5.86-5.86v-41.296c0-3.236,2.623-5.86,5.86-5.86 s5.86,2.624,5.86,5.86v41.296C63.557,493.106,60.933,495.73,57.696,495.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M80.356,495.73c-3.237,0-5.86-2.624-5.86-5.86v-41.296c0-3.236,2.623-5.86,5.86-5.86 s5.86,2.624,5.86,5.86v41.296C86.216,493.106,83.592,495.73,80.356,495.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C573"
    },
    d: "M103.016,495.73c-3.237,0-5.86-2.624-5.86-5.86v-41.296c0-3.236,2.623-5.86,5.86-5.86 s5.86,2.624,5.86,5.86v41.296C108.876,493.106,106.252,495.73,103.016,495.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0E7F9"
    },
    cx: 440.899,
    cy: 284.488,
    r: 20.316
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0E7F9"
    },
    cx: 32.468,
    cy: 85.506,
    r: 9.811
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C0E7F9"
    },
    cx: 494.814,
    cy: 254.998,
    r: 9.811
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M432.53,128.492c0,4.864-3.938,8.791-8.791,8.791H151.631l0.844-8.791 c0.281-2.965,0.68-5.896,1.184-8.791h270.081C428.592,119.701,432.53,123.64,432.53,128.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M291.027,78.004h-46.15c-7.539,0-13.65,6.111-13.65,13.65v28.048h73.45V91.654 C304.677,84.115,298.566,78.004,291.027,78.004z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.2,
    y: 402.445,
    style: {
      fill: "#E6E6E6"
    },
    width: 61.534,
    height: 31.645
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M313.835,260.383c0,0-0.668,1.641-2.075,4.231c-0.34,0.668-0.738,1.371-1.184,2.133 c-0.527,0.75-1.137,1.512-1.793,2.368c-0.656,0.856-1.406,1.723-2.203,2.684c-0.281,0.363-0.586,0.668-0.914,0.985 c-0.117,0.117-0.246,0.234-0.375,0.352c-0.457,0.422-0.926,0.867-1.407,1.313c-0.961,0.902-2.004,1.793-3.094,2.731 c-1.149,0.844-2.379,1.641-3.645,2.508c-0.633,0.434-1.289,0.856-1.957,1.278c-0.668,0.398-1.383,0.727-2.11,1.09 c-1.43,0.727-2.918,1.43-4.454,2.133c-3.165,1.078-6.458,2.344-9.974,2.872c-3.469,0.809-7.091,0.938-10.701,1.113 c-3.61-0.176-7.232-0.293-10.701-1.102c-3.516-0.527-6.81-1.793-9.974-2.872c-1.535-0.692-3.024-1.395-4.466-2.121 c-0.715-0.363-1.43-0.692-2.11-1.09c-0.656-0.434-1.313-0.844-1.946-1.278c-1.266-0.867-2.508-1.676-3.657-2.508 c-1.09-0.938-2.121-1.84-3.094-2.731c-0.481-0.457-0.938-0.891-1.395-1.324c-0.164-0.152-0.328-0.305-0.492-0.457 c-0.281-0.281-0.551-0.551-0.785-0.867c-0.762-0.926-1.5-1.782-2.145-2.625c-0.633-0.856-1.254-1.606-1.77-2.356 c-0.469-0.797-0.902-1.524-1.266-2.192c-1.465-2.672-2.075-4.266-2.075-4.266s1.735,0.527,4.407,1.606 c0.68,0.258,1.383,0.574,2.168,0.891c0.832,0.246,1.688,0.563,2.602,0.867c0.926,0.305,1.852,0.68,2.836,1.031 c0.973,0.375,2.075,0.621,3.165,0.949c1.09,0.316,2.18,0.703,3.317,1.043c1.184,0.258,2.368,0.563,3.587,0.856 c0.609,0.141,1.207,0.316,1.817,0.481c0.621,0.141,1.266,0.223,1.899,0.352c1.278,0.223,2.555,0.481,3.833,0.774 c2.661,0.246,5.286,0.832,8.029,0.938c2.707,0.352,5.474,0.258,8.216,0.422c2.754-0.164,5.52-0.059,8.228-0.41 c2.743-0.094,5.368-0.692,8.029-0.938c1.278-0.281,2.555-0.539,3.833-0.762c0.633-0.129,1.278-0.211,1.899-0.352 c0.609-0.176,1.219-0.34,1.817-0.481c1.219-0.293,2.403-0.609,3.587-0.856c1.149-0.34,2.239-0.727,3.329-1.043 c1.078-0.328,2.203-0.586,3.141-0.949c0.961-0.328,1.864-0.692,2.778-0.973c0.902-0.305,1.746-0.609,2.579-0.856 c0.82-0.352,1.547-0.692,2.239-0.961C312.136,260.875,313.835,260.383,313.835,260.383z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M305.666,272.783c-0.117,0.117-0.246,0.234-0.375,0.352c-0.457,0.422-0.926,0.867-1.407,1.313 c-0.961,0.903-2.004,1.793-3.094,2.731c-1.149,0.844-2.379,1.641-3.645,2.508c-0.633,0.434-1.289,0.856-1.957,1.278 c-0.668,0.398-1.383,0.727-2.11,1.09c-1.43,0.727-2.918,1.43-4.454,2.133c-3.165,1.078-6.458,2.344-9.974,2.872 c-3.469,0.809-7.091,0.938-10.701,1.113c-3.61-0.176-7.232-0.293-10.701-1.102c-3.516-0.527-6.81-1.793-9.974-2.872 c-1.535-0.692-3.024-1.395-4.466-2.121c-0.715-0.363-1.43-0.691-2.11-1.09c-0.656-0.434-1.313-0.844-1.946-1.278 c-1.266-0.867-2.508-1.676-3.657-2.508c-1.09-0.938-2.121-1.84-3.094-2.731c-0.481-0.457-0.938-0.891-1.395-1.324 c-0.164-0.152-0.328-0.305-0.492-0.457c0.375,0.129,0.75,0.258,1.137,0.387c0.926,0.305,1.852,0.668,2.836,1.02 c0.973,0.387,2.075,0.633,3.165,0.961c1.09,0.316,2.18,0.692,3.317,1.043c1.184,0.246,2.368,0.563,3.587,0.856 c0.609,0.141,1.207,0.305,1.817,0.469c0.621,0.141,1.266,0.223,1.899,0.352c1.278,0.223,2.555,0.492,3.833,0.774 c2.661,0.258,5.286,0.844,8.029,0.938c2.707,0.363,5.474,0.258,8.216,0.434c2.754-0.164,5.52-0.059,8.228-0.422 c2.743-0.094,5.368-0.68,8.029-0.926c1.278-0.281,2.555-0.551,3.833-0.774c0.633-0.129,1.278-0.211,1.899-0.352 c0.609-0.164,1.219-0.328,1.817-0.469c1.219-0.293,2.403-0.609,3.587-0.856c1.149-0.352,2.239-0.738,3.329-1.043 c1.078-0.328,2.203-0.598,3.141-0.949c0.961-0.34,1.864-0.692,2.778-0.985C304.951,273.03,305.314,272.901,305.666,272.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M215.775,221.12c-4.855,0-8.791-3.936-8.791-8.791V198.27c0-4.855,3.936-8.791,8.791-8.791 s8.791,3.936,8.791,8.791v14.06C224.566,217.185,220.63,221.12,215.775,221.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M300.031,170.726c0,0,0.023-0.233,0.102-0.634c0.09-0.388,0.182-1.001,0.379-1.695 c0.088-0.359,0.202-0.733,0.332-1.144c0.17-0.417,0.398-0.837,0.641-1.313c0.24-0.478,0.544-0.951,0.863-1.482 c0.321-0.539,0.704-0.948,1.097-1.469c0.398-0.5,0.847-0.985,1.316-1.505c0.496-0.47,1.034-0.933,1.606-1.398 c1.119-0.986,2.487-1.698,3.912-2.491c1.474-0.624,3.039-1.3,4.715-1.613c1.66-0.431,3.4-0.533,5.136-0.614 c1.736,0.08,3.478,0.172,5.138,0.601c1.677,0.309,3.243,0.989,4.719,1.608c1.426,0.791,2.795,1.503,3.916,2.489 c0.571,0.466,1.11,0.931,1.607,1.398c0.469,0.522,0.915,1.01,1.316,1.507c0.387,0.518,0.789,0.944,1.083,1.462 c0.295,0.516,0.581,0.978,0.813,1.445c0.231,0.469,0.455,0.881,0.624,1.297c0.154,0.434,0.289,0.826,0.39,1.198 c0.223,0.718,0.315,1.336,0.401,1.723c0.075,0.4,0.091,0.627,0.091,0.627s-0.243-0.006-0.653-0.046 c-0.398-0.052-1.017-0.077-1.701-0.177c-0.354-0.036-0.715-0.102-1.112-0.155c-0.423-0.02-0.84-0.079-1.294-0.114 c-0.89-0.094-1.818-0.233-2.839-0.273c-0.502-0.033-0.988-0.105-1.497-0.148c-0.526-0.007-1.046-0.034-1.561-0.073 c-1.01-0.131-2.109-0.054-3.128-0.182c-1.072,0.039-2.099-0.093-3.162-0.06c-1.046-0.079-2.103,0.005-3.152-0.069 c-1.049,0.072-2.106-0.02-3.154,0.056c-1.064-0.038-2.091,0.098-3.166,0.055c-1.021,0.127-2.121,0.048-3.132,0.181 c-0.516,0.039-1.035,0.067-1.562,0.073c-0.509,0.042-0.993,0.12-1.497,0.15c-1.041,0.056-1.906,0.155-2.774,0.23 c-0.456,0.035-0.883,0.068-1.278,0.097c-0.421,0.076-0.805,0.161-1.171,0.209c-0.709,0.125-1.329,0.155-1.723,0.205 C300.266,170.725,300.031,170.726,300.031,170.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M195.678,170.726c0,0,0.023-0.233,0.102-0.634c0.09-0.388,0.182-1.001,0.379-1.695 c0.088-0.359,0.202-0.733,0.332-1.144c0.17-0.417,0.398-0.837,0.641-1.313c0.24-0.478,0.544-0.951,0.863-1.482 c0.321-0.539,0.704-0.948,1.097-1.469c0.398-0.5,0.847-0.985,1.316-1.505c0.496-0.47,1.034-0.933,1.606-1.398 c1.119-0.986,2.487-1.698,3.912-2.491c1.474-0.624,3.039-1.3,4.715-1.613c1.66-0.431,3.4-0.533,5.136-0.614 c1.736,0.08,3.478,0.172,5.138,0.601c1.677,0.309,3.243,0.989,4.719,1.608c1.426,0.791,2.795,1.503,3.916,2.489 c0.571,0.466,1.11,0.931,1.607,1.398c0.469,0.522,0.915,1.01,1.316,1.507c0.387,0.518,0.789,0.944,1.083,1.462 c0.295,0.516,0.581,0.978,0.813,1.445c0.231,0.469,0.455,0.881,0.624,1.297c0.154,0.434,0.289,0.826,0.39,1.198 c0.223,0.718,0.315,1.336,0.401,1.723c0.075,0.4,0.091,0.627,0.091,0.627s-0.243-0.006-0.653-0.046 c-0.398-0.052-1.017-0.077-1.701-0.177c-0.354-0.036-0.715-0.102-1.112-0.155c-0.423-0.02-0.84-0.079-1.294-0.114 c-0.89-0.094-1.818-0.233-2.839-0.273c-0.502-0.033-0.988-0.105-1.497-0.148c-0.526-0.007-1.045-0.034-1.561-0.073 c-1.01-0.131-2.109-0.054-3.128-0.182c-1.072,0.039-2.099-0.093-3.162-0.06c-1.045-0.079-2.103,0.005-3.152-0.069 c-1.049,0.072-2.106-0.02-3.154,0.056c-1.064-0.038-2.091,0.098-3.166,0.055c-1.021,0.127-2.121,0.048-3.132,0.181 c-0.516,0.039-1.035,0.067-1.562,0.073c-0.509,0.042-0.993,0.12-1.497,0.15c-1.041,0.056-1.906,0.155-2.774,0.23 c-0.456,0.035-0.883,0.068-1.278,0.097c-0.421,0.076-0.805,0.161-1.171,0.209c-0.709,0.125-1.329,0.155-1.723,0.205 C195.912,170.725,195.678,170.726,195.678,170.726z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M320.129,221.12c-4.855,0-8.791-3.936-8.791-8.791V198.27c0-4.855,3.936-8.791,8.791-8.791 c4.855,0,8.791,3.936,8.791,8.791v14.06C328.92,217.185,324.984,221.12,320.129,221.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0B394"
    },
    d: "M281.431,185.377v41.609c0,7.444-6.035,13.479-13.479,13.479l0,0 c-7.444,0-13.479-6.035-13.479-13.479v-41.609"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanerSvgrepoCom);
export default __webpack_public_path__ + "static/media/cleaner-svgrepo-com.93ae5973055c71fa61052a75d5920802.svg";
export { ForwardRef as ReactComponent };